module.exports = __webpack_public_path__ + "img/prioritas_cod_k.23868a69.png";